import ReactDOM from 'react-dom';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmation de suppression",
  message = "Êtes-vous sûr de vouloir effectuer cette action ?",
  confirmText = "Supprimer",
  cancelText = "Annuler",
  type = "danger",
  loading = false
}) => {
  if (!isOpen) return null;

  // Couleurs selon le type
  const typeConfig = {
    danger: {
      buttonClass: 'btn-danger',
      icon: 'fas fa-exclamation-triangle',
      iconColor: 'text-danger'
    },
    warning: {
      buttonClass: 'btn-warning',
      icon: 'fas fa-exclamation-circle',
      iconColor: 'text-warning'
    },
    info: {
      buttonClass: 'btn-info',
      icon: 'fas fa-info-circle',
      iconColor: 'text-info'
    }
  };

  const config = typeConfig[type] || typeConfig.danger;

  return ReactDOM.createPortal(
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {/* En-tête */}
          <div className="modal-header">
            <h5 className="modal-title d-flex align-items-center">
              <i className={`${config.icon} ${config.iconColor} me-2`}></i>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={loading}
            ></button>
          </div>

          {/* Corps */}
          <div className="modal-body">
            <div className="text-center py-3">
              <i className={`${config.icon} ${config.iconColor} fa-3x mb-3`}></i>
              <p className="lead">{message}</p>
              <p className="text-muted small">
                Cette action est irréversible. Veuillez confirmer votre choix.
              </p>
            </div>
          </div>

          {/* Pied de page */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              disabled={loading}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className={`btn ${config.buttonClass} d-flex align-items-center`}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading && (
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Chargement...</span>
                </div>
              )}
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;